import React, { Component} from 'react';
import M from  'materialize-css/dist/js/materialize.min.js';
import 'materialize-css/dist/css/materialize.min.css';
import {getData,getData2,NotificationSend} from '../Api/Config'
import $ from 'jquery';

class Notification extends Component{
  
  
 state ={
   apps:[],
   appsCopy:[],
   selectedItem:[],
   name:'',
   name_err:'',
   platform_err:'',
   selectedItem_err:'',
   msg_title:'',
   msg_title_err:'',
   msg:'',
   msg_err:'',
   msg_imgUrl:'',
   topic:false,
   tab:this.props.match.params.id?this.props.location.state!==null && this.props.location.state.title?1:2:1,
   msg_imgUrl2:'',
   msg_imgUrl2_err:'',
   InputFields:[{ key: "", value: "" }]
 }


 clearFields=()=>{
   this.setState({
    selectedItem:[],
    name:'',
    name_err:'',
    platform_err:'',
    selectedItem_err:'',
    msg_title:'',
    msg_title_err:'',
    msg:'',
    msg_err:'',
    msg_imgUrl:'',
    tab:1,
    msg_imgUrl2:'',
    msg_imgUrl2_err:'',
    InputFields:[{ key: "", value: "" }]
   });
 }

 
 
 tabChanged=(n)=>{
    this.setState({tab:n})
 }

 componentDidUpdate(prevProps) {
  if (this.props.match.params !== prevProps.match.params) {
    const ID = this.props.match.params.id?this.props.match.params.id:null;
  
    if(ID===null){
      // console.log("asdsas");
      document.getElementById('Android').checked=true
      let el = document.querySelector('.tabs');
       M.Tabs.init(el, {});
       this.onSelectUiChange()
       this.clearFields();
      //  this.GetApps();
    }
  }
}

   isValid=()=>{
    let Flag = true
    const android = document.getElementById('Android').checked
    const IOS = document.getElementById('IOS').checked

        if(!android && !IOS){
          this.setState({
            platform_err:"* check a platform!"
          })
          Flag=false;
        }else{
          this.setState({
            platform_err:""
          })
        }

        if(this.state.name===undefined || this.state.name.trim().length===0){
          this.setState({
            name_err:"* name required...!"
          })
          Flag=false
        }else{
          this.setState({
            name_err:""
          })
        }
        if(this.state.selectedItem.length===0){
          this.setState({
            selectedItem_err:"* choose a app target!"
          })
          Flag=false
        }else{
          this.setState({
            selectedItem_err:""
          })
        }
        if(this.state.tab===1){
        if(this.state.msg_title===undefined || this.state.msg_title.trim()===''){
          this.setState({
            msg_title_err:"* title is required!"
          })
          Flag=false
        }else{
          this.setState({
            msg_title_err:""
          })
        }
        if(this.state.msg===undefined || this.state.msg.trim()===''){
          this.setState({
            msg_err:"* message is required!"
          })
          Flag=false
        }else{
          this.setState({
            msg_err:""
          })
        }
        this.setState({msg_imgUrl2_err:''})
      }else{
        
          if(this.state.msg_imgUrl2===undefined || this.state.msg_imgUrl2.trim().length===0){
            this.setState({msg_imgUrl2_err:'image is required!'})
            Flag=false
            
          }else{
            this.setState({msg_imgUrl2_err:''})
          }
          this.setState({msg_err:''})
          this.setState({msg_title_err:''})
      }

    return Flag;
   }
    
   get_selected=()=>{
    var data=[{id:1,name:"ABC"},{id:2,name:"XYZ"},{id:3,name:"PQR"}];
    
    var Options="";
    $.each(data, function(i, val){ 
      Options=Options+"<option value='"+val.id+"'>"+val.name+"</option>";
    });
    var elems = document.querySelectorAll('select');
    M.FormSelect.init(elems, {wrapper:Options});
  } 
    
    handleChange=e=>{
        const Id = e.target.id;
        const val = parseInt(e.target.value);
        
        if(Id==="selectedItem" && val!==0){
                if(this.state.selectedItem.indexOf(val)===-1){
                let ls = [...this.state.selectedItem,val];
                if(ls.includes(val)!==-1){
                  let arr = this.state.apps.length!==0 && this.state.apps.filter((app)=>app.id!==val)
                  this.setState({apps:[]})
                  this.setState({apps:arr})
                }
                this.setState({
                        selectedItem:ls
                })
                
            }
        }else{
          this.setState({
            [e.target.id]:e.target.value
           })
        }
       
    }

      delChip=(item)=>{
          const arr1 = this.state.appsCopy.length!==0 &&this.state.appsCopy.filter((app)=>app.id===item)
          let a = [...this.state.apps,arr1[0]];
          this.setState({apps:a})
          const arr =  this.state.selectedItem.filter((i)=> i!==item)
          this.setState({selectedItem:arr});
      }
   

    
     handleSubmit = event =>{
         event.preventDefault();
         if(this.isValid()){
          let addOn = this.DataHandle();
          let {tab,topic} = this.state;
          
          let main = {};
          if(tab===1){
              main={
              "campaignName":this.state.name,
              "title": this.state.msg_title,
              "body": this.state.msg,
              "imageURL": this.state.msg_imgUrl,
              "icon": "ic_baseline_add_alarm_24",
              "color": "#FDD835"
            }
          }else{
            main={
              "campaignName":this.state.name,
              "imageURL": this.state.msg_imgUrl2,
              "icon": "ic_baseline_add_alarm_24",
              "color": "#FDD835"
            }
          }

          if(topic){
            main = Object.assign(main,{"topic":"all"});
          }

          let request = {};
           
          if(Object.keys(addOn).length>0 && Object.keys(addOn)[0]){
            request = {
              "data": Object.assign(main,addOn),
              "appList": this.state.selectedItem
            }
          }else{
            request = {
              "data": main,
              "appList": this.state.selectedItem
            }
          }

         

        //  console.log('Success:',request)
          NotificationSend(request).then(res=>{
            this.clearFields();
            M.toast({html: "Successfully sent!"});
            console.log('Success:',res)
            this.props.history.push("/admin/NotificationHistory");
          }).catch(err=>{
            M.toast({html: "Somthing went wrong....!"});
            console.log('Error:',err)
          })
        
         }
      }

    onSelectUiChange(){
      var elems = document.querySelectorAll('select');
      M.FormSelect.init(elems, {});
    }
          
  componentDidMount(){
    this.onSelectUiChange()
    document.getElementById('Android').checked=true
    let el = document.querySelector('.tabs');
     M.Tabs.init(el, {});
     this.GetApps();
     if(this.props){
     const ID = this.props.match.params.id?this.props.match.params.id:null;
     if(ID!=null){
       if(this.props.location.state!==undefined && this.props.location.state.title){
        console.log("tab1");
        const {body,imageURL,title,campaignName} = this.props.location.state;
          this.setState({
            msg_title:title,
            msg:body,
            msg_imgUrl:imageURL,
            tab:1,
            name:campaignName
          })
       }else{
         console.log("tab2");
        const {imageURL,campaignName} = this.props.location.state;
        this.setState({msg_imgUrl2:imageURL,name:campaignName});
       }
     }
    }
}

GetAppInfo=(ID)=>{
  //this app info is fro individual app info id
   getData(`apps/${ID}`).then(result=>{
    this.setState({
            selectedItem:[...this.state.selectedItem,result.id]
    })
   })
}

GetNotificationInfo=(ID)=>{
  getData2('https://api.nirmallabs.com/api/v1/fcm/notification-details/'+ID).then(res=>{
   res.appList && res.appList.map(app=>{
      return this.GetAppInfo(app)
    })
    this.setState({
      msg_title:res.title,
      msg:res.message,
      tab:1
    })
    document.getElementById("msg_title").focus()
    document.getElementById("msg").focus()
  })
}

appInfo(ID){
  //this is for getting all apps info name and package name
  return this.state.appsCopy && this.state.appsCopy.filter(app=> app.id===ID)[0]
}

GetApps=()=>{
  getData("apps").then(res=>{
      if(res.applications){
        const pub = res.applications.map(ls=>{
         return ls
        })
        const appLs = pub && pub.map(app=>{
          return app.applications
        })
        
       appLs && appLs.map(apps=>{
         return apps && apps.map(app=>{
            return this.setState({
              apps:[...this.state.apps,{
              id:app.id,
              name:app.name,
              appId:app.appId
              }]
            })
          })
        })
        this.setState({appsCopy:this.state.apps})
        var elems = document.querySelectorAll('select');
        M.FormSelect.init(elems, {});
        // console.log(this.state.apps)
      }
  }).catch(err=>{
    console.log(err)
  })
}

 handleChangeData = (index, e) => {
  const values = [...this.state.InputFields];
  values[index][e.target.name] = e.target.value;
  this.setState({InputFields:values});
  // console.log(this.state.InputFields)
};

AddNewField = () => {
  this.setState({InputFields:[...this.state.InputFields, { key: "", value: "" }]});
};

RemoveField = (index) => {
  const values = [...this.state.InputFields];
  values.splice(index, 1);
  this.setState({InputFields:values});
};

DataHandle=()=>{
  const data = {}
  this.state.InputFields.forEach((value)=>{
    data[value.key]=value.value
  })
  return data;
}


    
render() { 
    
    const {apps} = this.state;
    let appsList = apps && [...apps].map((app)=>{
     return <option key={app.id} value={app.id}>{app.name}</option>
    });
    let  {topic} = this.state;
   
    return (

      <div className="card white darken-1">
        <div className="card-content white-text">
        <form onSubmit={this.handleSubmit}>
        <span className="card-title black-text"><center>Notification</center></span>
          <div className="row">
        <div className="input-field col s12">
          <input id="name" value={this.state.name} type="text" className="validate"  onChange={this.handleChange}/>
          <label className="active" htmlFor="name">Name of Campaign</label>
          <div style={{fontSize:12 ,color:"red",marginLeft:30}} >{this.state.name_err}</div>
        </div>
      </div>
      <div className="row">
      <label>Choose Platform</label>
      <div className="input-field col s12">

      <p>
      <label htmlFor="Android">
        <input id="Android" type="checkbox" />
        <span>Android</span>
      </label>
    </p>
    <p  style={{marginTop:10}}>
      <label htmlFor="IOS" >
        <input id="IOS" type="checkbox"/>
        <span>iOS</span>
      </label>
      </p>
      <div style={{fontSize:12 ,color:"red",marginLeft:30}} >{this.state.platform_err}</div>
        </div>
      </div>
      <div className="row">
    <label>Target Audience</label>

      <div className="input-field col s12">
      <select className="browser-default" defaultValue="0" onChange={this.handleChange} id="selectedItem">
      <option value="0">Choose your apps</option>
      {appsList}
    </select>
    <div style={{fontSize:12 ,color:"red",marginLeft:30}} >{this.state.selectedItem_err}</div>

    </div>
    </div>
    <div className="row">
      <div className="input-field col s12">
        <p style={{color:"grey"}}>Target Apps</p>
          {this.state.selectedItem.length?this.state.selectedItem.map(item=>{
            return (
              <div key={item} className="col">
              <span className="btn btn-small green" style={{marginRight:5}} onClick={()=>this.delChip(item)}>{this.appInfo(item).name}<i className="material-icons right">close</i></span>
               <br/>
               <p style={{color:'black'}}>{this.appInfo(item).appId}</p>
              </div>
              )
          }):null}
        </div>
      </div>

      <div className="row">
        <div className="input-field col s12">
        <p>
            <label>
              <input type="checkbox" onClick={()=>topic?this.setState({"topic":false}):this.setState({"topic":true})} id="topic" className="filled-in "/>
              <span>Topic</span>
            </label>
          </p>
        </div>
      </div>
     
      <div className="row">
    <div className="col s12">
      <ul className="tabs ">
        <li className="tab col s3" onClick={()=>this.tabChanged(1)} disabled><a  style={{color:'black'}} className={this.state.tab===1 ? "active":"inactive"} href="#test1">Text Message</a></li>
        <li className="tab col s3" onClick={()=>this.tabChanged(2)}><a style={{color:'black'}} className={this.state.tab===2 ? "active":"inactive"}  href="#test2">Content Image</a></li>
      </ul>
    </div>
    <div id="test1" className="col s12">
    <div className="card white darken-1">
        <div className="card-content white-text">
          <div className="row">
        <div className="input-field col s12">
        <input  id="msg_title" type="text" value={this.state.msg_title} className="validate"  onChange={this.handleChange}/>
          <label className="active" htmlFor="msg_title">Title</label>
          <div style={{fontSize:12 ,color:"red",marginLeft:30}}>{this.state.msg_title_err}</div>
        </div>
        </div>
        <div className="row">
        <div className="input-field col s12">
          <textarea id="msg" className="materialize-textarea"  onChange={this.handleChange} style={{height:150}} value={this.state.msg} ></textarea>
          <label className="active" htmlFor="msg" >MESSAGE</label>
          <div style={{fontSize:12 ,color:"red",marginLeft:30}}>{this.state.msg_err}</div>
        </div>
      </div>
      
      <div className="row">
        <div className="input-field col s12">
        <input id="msg_imgUrl" type="text" value={this.state.msg_imgUrl} className="validate"  onChange={this.handleChange}/>
          <label className="active" htmlFor="msg_imgUrl">Image url (optional):</label>
        </div>
        </div>

      </div>
      </div>

      

      </div>

    <div id="test2" className="col s12">
    <div className="card white darken-1">
        <div className="card-content white-text">
          <div className="row">
        <div className="input-field col s12">
        <input id="msg_imgUrl2" type="text" className="validate" value={this.state.msg_imgUrl2}  onChange={this.handleChange}/>
          <label className="active" htmlFor="msg_imgUrl2">Enter Image URL</label>
       </div>
       <div style={{fontSize:12 ,color:"red",marginLeft:30}}>{this.state.msg_imgUrl2_err}</div>
      </div>
      </div>
      </div>
     
  </div>
  <div className="row">
  <label style={{fontSize: '17px',color: 'black',fontWeight: 400,marginLeft:20}}>Additional Data:</label>
  <div className="input-field col s12">
          {
            this.state.InputFields.map((InputField,index)=>{
              return(
                <div className="row" key={index}>
                <div className="col s4">
                <input name="key" type="text" value={InputField.key} onChange={(e) => this.handleChangeData(index, e)} className="validate" placeholder="key" />
                </div>
                <div className="col s6">
                <input name="value" type="text" value={InputField.value} onChange={(e) => this.handleChangeData(index, e)} className="validate" placeholder="value" />
                </div>
                <div className="col s2">
                <span onClick={this.AddNewField} className="btn-floating btn-small waves-effect waves-light red" style={{marginRight: '5px'}}><i className="material-icons">add</i></span>
                {index!==0?<span onClick={() => this.RemoveField(index)} className="btn-floating btn-small waves-effect waves-light blue"><i className="material-icons">remove</i></span>:null}
                </div>
                </div>
              )
            })
          }
          </div>
      </div>
  <button className="btn waves-effect waves-light blue" type="submit" name="action" style={{diplay:"block",margin:'auto'}}>Send Notification
    <i className="material-icons right" style={{float:"right"}}>send</i>
  </button>
  </div>
    </form>
  </div>
  </div>
    )
        
  }
}
export default Notification;